import $ from 'jquery';
import '@/user/common';
import React from 'react';
import ReactDom from 'react-dom';
import DetailStatus from '@/user/components/fair/detail_status.js';
import { sliderSetting, setColorClass } from '@/shared/calendar';

// カレンダーの日付
const inputDateCheckBox = '.calendar input[name="date[]"]';

// 日付別の開催時間初期表示
const initializeFairDetailStatus = () => {
    const $selectedDate = $(`${inputDateCheckBox}:checked`).first();
    if ($selectedDate.length > 0) {
        const date = $selectedDate.val();
        const formattedDate = $selectedDate.data('date');

        renderFairDetailStatus(date, formattedDate);
    }
};

// 日付別の開催時間表示
const renderFairDetailStatus = (date, formattedDate) => {
    const fairDetailStatus = document.getElementById('fair-detail-status');
    const fairDays = fairDetailStatus.dataset.fair_days;
    const isCustomForm = fairDetailStatus.dataset.custom_form; // オリジナルフォーム利用しているか

    if (fairDays) {
        ReactDom.render(
            <DetailStatus
                date={date}
                formattedDate={formattedDate}
                fairDays={JSON.parse(fairDays)}
                isCustomForm={JSON.parse(isCustomForm)}
            />,
            fairDetailStatus,
        );
    }
};

// 日付別の開催時間削除
const removeFairDetailStatus = () => {
    const fairDetailStatus = document.getElementById('fair-detail-status');

    ReactDom.unmountComponentAtNode(fairDetailStatus);
};

$(() => {
    // 日付別の開催時間初期表示
    initializeFairDetailStatus();

    // カレンダーのカルーセル
    sliderSetting(true, false);

    // カレンダーの日付選択
    $(inputDateCheckBox).on('click', e => {
        $(inputDateCheckBox)
            .not(e.currentTarget)
            .prop('checked', false); // 選択した日付以外のチェック外す
        setColorClass(); // 日付にclass付与
        if (e.currentTarget.checked) {
            const date = e.currentTarget.value; // YYYY-MM-DD
            const formattedDate = e.currentTarget.dataset.date; // YYYY年MM月dd日(a)

            renderFairDetailStatus(date, formattedDate);
        } else {
            removeFairDetailStatus();
        }
    });
});
